module.exports = __webpack_public_path__ + "img/password.d2c51cae.svg";